/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MSP06DataDto { 
    sno?: string | null;
    rkey?: string | null;
    rvalue1?: number | null;
    rvalue2?: number | null;
    rvalue3?: string | null;
    rvalue4?: number | null;
    rvalue5?: number | null;
}

